import React from "react";

import "./App.css";
import MainRoutes from "./routes/mainroutes";

function App() {
  return (
    <div className="App">
      <MainRoutes />
    </div>
  );
}

export default App;
